import { makeAuthorizedApiClient } from '@percept/hooks'

const { VODAFONE_CUSTOM_API_ROOT } = process.env

export const sponsorshipsApiClient = makeAuthorizedApiClient({
  baseURL: `${VODAFONE_CUSTOM_API_ROOT}/sponsorships/v1`,
})
